import { createAction, createAsyncActions } from './utils'

const reducer = 'APARTMENTS'

const selectApartment = createAction(reducer, 'SELECT')
const deselectApartment = createAction(reducer, 'DESELECT')
const showApartmentDialog = createAction(reducer, 'SHOW_APARTMENT_DIALOG')
const stepBack = createAction(reducer, 'STEP_BACK')
const stepInstantRentBack = createAction(reducer, 'STEP_INSTANT_RENT_BACK')
const stepAfterShowingBack = createAction(reducer, 'STEP_AFTER_SHOWING_BACK')
const stepForward = createAction(reducer, 'STEP_FORWARD')
const stepInstantRentForward = createAction(
  reducer,
  'STEP_INSTANT_RENT_FORWARD'
)
const stepAfterShowingForward = createAction(reducer, 'STEP_AFTER_SHOWING_FORWARD')
const stepClick = createAction(reducer, 'STEP_CLICK')
const instantRentStepCLick = createAction(reducer, 'INSTANT_RENT_STEP_CLICK')

const {
  action: createApartment,
  actionSuccess: createApartmentSuccess,
  actionFail: createApartmentFail
} = createAsyncActions(reducer, 'CREATE')

const {
  action: getApartment,
  actionSuccess: getApartmentSuccess,
  actionFail: getApartmentFail
} = createAsyncActions(reducer, 'GET')

const {
  action: getApartmentByCode,
  actionSuccess: getApartmentByCodeSuccess,
  actionFail: getApartmentByCodeFail
} = createAsyncActions(reducer, 'GET_BY_CODE')

const {
  action: listApartments,
  actionSuccess: listApartmentsSuccess,
  actionFail: listApartmentsFail
} = createAsyncActions(reducer, 'LIST_APARTMENTS')

const {
  action: searchApartments,
  actionSuccess: searchApartmentsSuccess,
  actionFail: searchApartmentsFail
} = createAsyncActions(reducer, 'SEARCH_APARTMENTS')

const {
  action: removeApartment,
  actionSuccess: removeApartmentSuccess,
  actionFail: removeApartmentFail
} = createAsyncActions(reducer, 'REMOVE')

const {
  action: updateApartmentCode,
  actionSuccess: updateApartmentCodeSuccess,
  actionFail: updateApartmentCodeFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_CODE')

const {
  action: updateApartmentClientInformation,
  actionSuccess: updateApartmentClientInformationSuccess,
  actionFail: updateApartmentClientInformationFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_CLIENT')

const {
  action: updateApartmentClientInformationToOverview,
  actionSuccess: updateApartmentClientInformationToOverviewSuccess,
  actionFail: updateApartmentClientInformationToOverviewFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_CLIENT_TO_OVERVIEW')

const {
  action: updateApartmentClientInformationWithStatus,
  actionSuccess: updateApartmentClientInformationWithStatusSuccess,
  actionFail: updateApartmentClientInformationWithStatusFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_CLIENT_WITH_STATUS')

const {
  action: updateApartmentInformation,
  actionSuccess: updateApartmentInformationSuccess,
  actionFail: updateApartmentInformationFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT')

const {
  action: updateApartmentMedia,
  actionSuccess: updateApartmentMediaSuccess,
  actionFail: updateApartmentMediaFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_MEDIA')

const {
  action: getApartmentMedia,
  actionSuccess: getApartmentMediaSuccess,
  actionFail: getApartmentMediaFail
} = createAsyncActions(reducer, 'GET_APARTMENT_MEDIA')

const {
  action: getAllMedia,
  actionSuccess: getAllMediaSuccess,
  actionFail: getAllMediaFail
} = createAsyncActions(reducer, 'GET_ALL_MEDIA')

const {
  action: deleteApartmentMedia,
  actionSuccess: deleteApartmentMediaSuccess,
  actionFail: deleteApartmentMediaFail
} = createAsyncActions(reducer, 'DELETE_APARTMENT_MEDIA')

const {
  action: reorderApartmentMedia,
  actionSuccess: reorderApartmentMediaSuccess,
  actionFail: reorderApartmentMediaFail
} = createAsyncActions(reducer, 'REORDER_APARTMENT_MEDIA')

const {
  action: addApartmentMedia,
  actionSuccess: addApartmentMediaSuccess,
  actionFail: addApartmentMediaFail
} = createAsyncActions(reducer, 'ADD_APARTMENT_MEDIA')

const {
  action: confirmMedia,
  actionSuccess: confirmMediaSuccess,
  actionFail: confirmMediaFail
} = createAsyncActions(reducer, 'CONFIRM_MEDIA')

const {
  action: updateApartmentConfirmation,
  actionSuccess: updateApartmentConfirmationSuccess,
  actionFail: updateApartmentConfirmationFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_CONFIRMATION')

const { action: updateApartmentViewed } = createAsyncActions(
  reducer,
  'UPDATE_APARTMENT_VIEWED'
)

const {
  action: updateStatus,
  actionSuccess: updateStatusSuccess,
  actionFail: updateStatusFail
} = createAsyncActions(reducer, 'UPDATE_STATUS')

const {
  action: updateStatusWithForm,
  actionSuccess: updateStatusWithFormSuccess,
  actionFail: updateStatusWithFormFail
} = createAsyncActions(reducer, 'UPDATE_STATUS_WITH_FORM')

const {
  action: updateApartmentAdminInfo,
  actionSuccess: updateApartmentAdminInfoSuccess,
  actionFail: updateApartmentAdminInfoFail
} = createAsyncActions(reducer, 'UPDATE_APARTMENT_ADMIN_INFO')

const {
  action: updateApartmentUserId,
  actionSuccess: updateApartmentUserIdSuccess,
  actionFail: updateApartmentUserIdFail
} = createAsyncActions(reducer, 'UPDATE_USER_ID')

const {
  action: initializeBeforeLoginApartment,
  actionSuccess: initializeBeforeLoginApartmentSuccess,
  actionFail: initializeBeforeLoginApartmentFail
} = createAsyncActions(reducer, 'INITIALIZE_BEFORE_LOGIN')

const {
  action: saveBeforeLoginApartmentInfo,
  actionSuccess: saveBeforeLoginApartmentInfoSuccess,
  actionFail: saveBeforeLoginApartmentInfoFail
} = createAsyncActions(reducer, 'SAVE_BEFORE_LOGIN_INFO')

const {
  action: saveInstantRentApplicationInfo,
  actionSuccess: saveInstantRentApplicationInfoSuccess,
  actionFail: saveInstantRentApplicationInfoFail
} = createAsyncActions(reducer, 'SAVE_INSTANT_RENT_APPLICATION_INFO')

const {
  action: addBeforeLoginApartmentMedia,
  actionSuccess: addBeforeLoginApartmentMediaSuccess,
  actionFail: addBeforeLoginApartmentMediaFail
} = createAsyncActions(reducer, 'ADD_BEFORE_LOGIN_MEDIA')

const {
  action: deleteBeforeLoginApartmentMedia,
  actionSuccess: deleteBeforeLoginApartmentMediaSuccess,
  actionFail: deleteBeforeLoginApartmentMediaFail
} = createAsyncActions(reducer, 'DELETE_BEFORE_LOGIN_MEDIA')

const {
  action: reorderBeforeLoginApartmentMedia,
  actionSuccess: reorderBeforeLoginApartmentMediaSuccess,
  actionFail: reorderBeforeLoginApartmentMediaFail
} = createAsyncActions(reducer, 'REORDER_BEFORE_LOGIN_MEDIA')

const {
  action: confirmBeforeLoginApartmentMedia,
  actionSuccess: confirmBeforeLoginApartmentMediaSuccess,
  actionFail: confirmBeforeLoginApartmentMediaFail
} = createAsyncActions(reducer, 'CONFIRM_BEFORE_LOGIN_MEDIA')

const {
  action: confirmBeforeLoginApartment,
  actionSuccess: confirmBeforeLoginApartmentSuccess,
  actionFail: confirmBeforeLoginApartmentFail
} = createAsyncActions(reducer, 'CONFIRM_BEFORE_LOGIN')
const {
  action: signUpBeforeLogin,
  actionSuccess: signUpBeforeLoginSuccess,
  actionFail: signUpBeforeLoginFail
} = createAsyncActions(reducer, 'SIGN_UP_BEFORE_LOGIN')

const {
  action: addMissingClientInfo,
  actionSuccess: addMissingClientInfoSuccess,
  actionFail: addMissingClientInfoFail
} = createAsyncActions(reducer, 'ADD_MISSING_CLIENT_INFO')

const {
  action: addMissingClientInfoToOverview,
  actionSuccess: addMissingClientInfoToOverviewSuccess,
  actionFail: addMissingClientInfoToOverviewFail
} = createAsyncActions(reducer, 'ADD_MISSING_CLIENT_INFO_TO_OVERVIEW')

const emptyBeforeLoginState = createAction(reducer, 'EMPTY_BEFORE_LOGIN')
const addSwitchedData = createAction(reducer, 'ADD_SWITCHED_DATA')

export {
  selectApartment,
  deselectApartment,
  getApartment,
  getApartmentSuccess,
  getApartmentFail,
  getApartmentByCode,
  getApartmentByCodeSuccess,
  getApartmentByCodeFail,
  createApartment,
  createApartmentSuccess,
  createApartmentFail,
  listApartments,
  listApartmentsSuccess,
  listApartmentsFail,
  searchApartments,
  searchApartmentsSuccess,
  searchApartmentsFail,
  showApartmentDialog,
  removeApartment,
  removeApartmentSuccess,
  removeApartmentFail,
  updateApartmentCode,
  updateApartmentCodeSuccess,
  updateApartmentCodeFail,
  updateApartmentClientInformation,
  updateApartmentClientInformationSuccess,
  updateApartmentClientInformationFail,
  updateApartmentClientInformationWithStatus,
  updateApartmentClientInformationWithStatusSuccess,
  updateApartmentClientInformationWithStatusFail,
  updateApartmentClientInformationToOverview,
  updateApartmentClientInformationToOverviewSuccess,
  updateApartmentClientInformationToOverviewFail,
  updateApartmentInformation,
  updateApartmentInformationSuccess,
  updateApartmentInformationFail,
  updateApartmentMedia,
  updateApartmentMediaSuccess,
  updateApartmentMediaFail,
  getApartmentMedia,
  getApartmentMediaSuccess,
  getApartmentMediaFail,
  getAllMedia,
  getAllMediaSuccess,
  getAllMediaFail,
  addApartmentMedia,
  addApartmentMediaSuccess,
  addApartmentMediaFail,
  confirmMedia,
  confirmMediaSuccess,
  confirmMediaFail,
  deleteApartmentMedia,
  deleteApartmentMediaSuccess,
  deleteApartmentMediaFail,
  reorderApartmentMedia,
  reorderApartmentMediaSuccess,
  reorderApartmentMediaFail,
  updateApartmentConfirmation,
  updateApartmentConfirmationSuccess,
  updateApartmentConfirmationFail,
  updateApartmentViewed,
  stepBack,
  stepInstantRentBack,
  stepAfterShowingBack,
  stepForward,
  stepInstantRentForward,
  stepAfterShowingForward,
  stepClick,
  instantRentStepCLick,
  updateStatus,
  updateStatusSuccess,
  updateStatusFail,
  updateApartmentAdminInfo,
  updateApartmentAdminInfoSuccess,
  updateApartmentAdminInfoFail,
  updateStatusWithForm,
  updateStatusWithFormSuccess,
  updateStatusWithFormFail,
  updateApartmentUserId,
  updateApartmentUserIdSuccess,
  updateApartmentUserIdFail,
  initializeBeforeLoginApartment,
  initializeBeforeLoginApartmentSuccess,
  initializeBeforeLoginApartmentFail,
  saveBeforeLoginApartmentInfo,
  saveBeforeLoginApartmentInfoSuccess,
  saveBeforeLoginApartmentInfoFail,
  saveInstantRentApplicationInfo,
  saveInstantRentApplicationInfoSuccess,
  saveInstantRentApplicationInfoFail,
  addBeforeLoginApartmentMedia,
  addBeforeLoginApartmentMediaSuccess,
  addBeforeLoginApartmentMediaFail,
  deleteBeforeLoginApartmentMedia,
  deleteBeforeLoginApartmentMediaSuccess,
  deleteBeforeLoginApartmentMediaFail,
  reorderBeforeLoginApartmentMedia,
  reorderBeforeLoginApartmentMediaSuccess,
  reorderBeforeLoginApartmentMediaFail,
  confirmBeforeLoginApartmentMedia,
  confirmBeforeLoginApartmentMediaSuccess,
  confirmBeforeLoginApartmentMediaFail,
  confirmBeforeLoginApartment,
  confirmBeforeLoginApartmentSuccess,
  confirmBeforeLoginApartmentFail,
  addMissingClientInfo,
  addMissingClientInfoSuccess,
  addMissingClientInfoFail,
  addMissingClientInfoToOverview,
  addMissingClientInfoToOverviewSuccess,
  addMissingClientInfoToOverviewFail,
  emptyBeforeLoginState,
  signUpBeforeLogin,
  signUpBeforeLoginSuccess,
  signUpBeforeLoginFail,
  addSwitchedData
}
